<template>
	<div class="flex flex-col gap-4">
		<div class="flex flex-col gap-4">
			<div
				v-for="(group, i) in timeconditions.rules"
				:key="i"
				class="mt-4 flex flex-col border-t pt-3 first:mt-0 first:border-t-0 first:pt-0"
			>
				<div class="flex flex-col gap-2 px-2 pb-4">
					<div class="hidden justify-between gap-4 sm:flex sm:flex-row sm:items-center">
						<label class="flex-1" for="condition-0">Condition:</label>
						<label class="w-40" for="from">From:</label>
						<label class="w-40" for="to">To:</label>
						<label v-if="!readonly" class="w-16"></label>
					</div>
					<div
						v-for="(rule, j) in group"
						:key="j"
						class="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center sm:gap-4"
					>
						<div class="formGroup withIcon w-full sm:w-auto sm:flex-1">
							<label class="mb-1 block sm:hidden" for="condition">Condition:</label>
							<select
								id="condition"
								v-model="rule.condition"
								:disabled="readonly"
								class="w-full"
								@change="setDefaults(rule)"
							>
								<option value="date-range">Date Range</option>
								<option value="time-of-day">Time of Day</option>
								<option value="day-of-week">Day of Week</option>
								<option value="day-of-month">Day of Month</option>
								<option value="week-of-month">Week of Month</option>
								<option value="week">Week</option>
								<option value="month">Month</option>
								<option value="year">Year</option>
							</select>
							<span class="fa-light fa-chevron-down"></span>
						</div>
						<div class="formGroup w-full sm:w-40" :class="{ withIcon: shouldShowIconLow(rule.condition) }">
							<label class="mb-1 block sm:hidden" for="from">From:</label>
							<input
								v-if="rule.condition === 'date-range'"
								id="from"
								v-model="rule.from"
								type="date"
								:disabled="readonly"
								class="w-full"
							/>
							<input
								v-if="rule.condition === 'time-of-day'"
								id="from"
								v-model="rule.from"
								type="time"
								:disabled="readonly"
								class="w-full"
							/>
							<select
								v-if="rule.condition === 'day-of-week'"
								id="from"
								v-model="rule.from"
								:disabled="readonly"
								class="w-full"
							>
								<option :value="1">Monday</option>
								<option :value="2">Tuesday</option>
								<option :value="3">Wednesday</option>
								<option :value="4">Thursday</option>
								<option :value="5">Friday</option>
								<option :value="6">Saturday</option>
								<option :value="7">Sunday</option>
							</select>
							<select
								v-if="rule.condition === 'day-of-month'"
								id="from"
								v-model="rule.from"
								:disabled="readonly"
								class="w-full"
							>
								<option v-for="i in 31" :key="i" :value="i">{{ i }}</option>
							</select>
							<select
								v-if="rule.condition === 'week-of-month'"
								id="from"
								v-model="rule.from"
								:disabled="readonly"
								class="w-full"
							>
								<option :value="1">1</option>
								<option :value="2">2</option>
								<option :value="3">3</option>
								<option :value="4">4</option>
								<option :value="5">5</option>
							</select>
							<select
								v-if="rule.condition === 'week'"
								id="from"
								v-model="rule.from"
								:disabled="readonly"
								class="w-full"
							>
								<option v-for="i in 52" :key="i" :value="i">{{ i }}</option>
							</select>
							<select
								v-if="rule.condition === 'month'"
								id="from"
								v-model="rule.from"
								:disabled="readonly"
								class="w-full"
							>
								<option :value="1">January</option>
								<option :value="2">February</option>
								<option :value="3">March</option>
								<option :value="4">April</option>
								<option :value="5">May</option>
								<option :value="6">June</option>
								<option :value="7">July</option>
								<option :value="8">August</option>
								<option :value="9">September</option>
								<option :value="10">October</option>
								<option :value="11">November</option>
								<option :value="12">December</option>
							</select>
							<span v-if="shouldShowIconLow(rule.condition)" class="fa-light fa-chevron-down"></span>
							<input
								v-if="rule.condition === 'year'"
								id="from"
								v-model="rule.from"
								type="number"
								value="2024"
								:disabled="readonly"
								class="w-full"
							/>
						</div>
						<div class="formGroup w-full sm:w-40" :class="{ withIcon: shouldShowIconLow(rule.condition) }">
							<label class="mb-1 block sm:hidden" for="to">To:</label>
							<input
								v-if="rule.condition === 'date-range'"
								id="to"
								v-model="rule.to"
								type="date"
								:disabled="readonly"
								class="w-full"
							/>
							<input
								v-if="rule.condition === 'time-of-day'"
								id="to"
								v-model="rule.to"
								type="time"
								:disabled="readonly"
								class="w-full"
							/>
							<select
								v-if="rule.condition === 'day-of-week'"
								id="to"
								v-model="rule.to"
								:disabled="readonly"
								class="w-full"
							>
								<option :value="1">Monday</option>
								<option :value="2">Tuesday</option>
								<option :value="3">Wednesday</option>
								<option :value="4">Thursday</option>
								<option :value="5">Friday</option>
								<option :value="6">Saturday</option>
								<option :value="7">Sunday</option>
							</select>
							<select
								v-if="rule.condition === 'day-of-month'"
								id="to"
								v-model="rule.to"
								:disabled="readonly"
								class="w-full"
							>
								<option v-for="i in 31" :key="i" :value="i">{{ i }}</option>
							</select>
							<select
								v-if="rule.condition === 'week-of-month'"
								id="to"
								v-model="rule.to"
								:disabled="readonly"
								class="w-full"
							>
								<option :value="1">1</option>
								<option :value="2">2</option>
								<option :value="3">3</option>
								<option :value="4">4</option>
								<option :value="5">5</option>
							</select>
							<select
								v-if="rule.condition === 'week'"
								id="to"
								v-model="rule.to"
								:disabled="readonly"
								class="w-full"
							>
								<option v-for="i in 52" :key="i" :value="i">{{ i }}</option>
							</select>
							<select
								v-if="rule.condition === 'month'"
								id="to"
								v-model="rule.to"
								:disabled="readonly"
								class="w-full"
							>
								<option :value="1">January</option>
								<option :value="2">February</option>
								<option :value="3">March</option>
								<option :value="4">April</option>
								<option :value="5">May</option>
								<option :value="6">June</option>
								<option :value="7">July</option>
								<option :value="8">August</option>
								<option :value="9">September</option>
								<option :value="10">October</option>
								<option :value="11">November</option>
								<option :value="12">December</option>
							</select>
							<span v-if="shouldShowIconLow(rule.condition)" class="fa-light fa-chevron-down"></span>
							<input
								v-if="rule.condition === 'year'"
								id="to"
								v-model="rule.to"
								type="number"
								value="2024"
								:disabled="readonly"
								class="w-full"
							/>
						</div>
						<div
							v-if="!readonly && j === group.length - 1"
							class="mt-2 flex w-full items-center justify-end sm:mt-0 sm:w-16 sm:justify-start"
						>
							<button
								:disabled="group.length === 1"
								class="fa-light fa-remove"
								:class="{ 'opacity-50': group.length === 1 }"
								@click="removeRuleFromGroup(i, j)"
							></button>
							<button class="fa-light fa-add ml-2" @click="addRuleToGroup(i)"></button>
						</div>
						<div
							v-if="!readonly && j !== group.length - 1"
							class="mt-2 flex w-full justify-end sm:mt-0 sm:w-16 sm:justify-start"
						>
							<button class="fa-light fa-remove" @click="removeRuleFromGroup(i, j)"></button>
						</div>
					</div>
				</div>
				<div v-if="!readonly" class="flex flex-col justify-end gap-2 px-2 pt-4 sm:flex-row sm:items-center">
					<button
						v-if="timeconditions.rules.length > 1"
						class="jmiBtn red w-full sm:w-40"
						@click="removeRuleGroup(i)"
					>
						Remove Group
					</button>
					<button
						v-if="i === timeconditions.rules.length - 1"
						class="jmiBtn green w-full sm:w-32"
						@click="addGroup()"
					>
						Add Group
					</button>
				</div>
			</div>
		</div>

		<div class="flex flex-col gap-4">
			<div class="mb-6 mt-2 w-full border-b border-dark dark:border-light">
				<h2 class="mb-2">Public Holiday Exceptions</h2>
			</div>
			<div class="flex flex-col">
				<div class="grid grid-cols-1 gap-4 px-2 pb-4 sm:grid-cols-2">
					<div class="flex items-center">
						<input
							id="new-year"
							v-model="timeconditions.exceptions.fixedExceptions"
							type="checkbox"
							value="new-year"
							:disabled="readonly"
						/>
						<label for="new-year" class="pl-3">New Year's Day</label>
					</div>
					<div class="flex items-center">
						<input
							id="good-friday"
							v-model="timeconditions.exceptions.fixedExceptions"
							type="checkbox"
							value="good-friday"
							:disabled="readonly"
						/>
						<label for="good-friday" class="pl-3">Good Friday</label>
					</div>
					<div class="flex items-center">
						<input
							id="easter-sunday"
							v-model="timeconditions.exceptions.fixedExceptions"
							type="checkbox"
							value="easter-sunday"
							:disabled="readonly"
						/>
						<label for="easter-sunday" class="pl-3">Easter Sunday</label>
					</div>
					<div class="flex items-center">
						<input
							id="easter-monday"
							v-model="timeconditions.exceptions.fixedExceptions"
							type="checkbox"
							value="easter-monday"
							:disabled="readonly"
						/>
						<label for="easter-monday" class="pl-3">Easter Monday</label>
					</div>
					<div class="flex items-center">
						<input
							id="spring-bank-holiday"
							v-model="timeconditions.exceptions.fixedExceptions"
							type="checkbox"
							value="spring-bank-holiday"
							:disabled="readonly"
						/>
						<label for="spring-bank-holiday" class="pl-3">Spring Bank Holiday</label>
					</div>
					<div class="flex items-center">
						<input
							id="may-day"
							v-model="timeconditions.exceptions.fixedExceptions"
							type="checkbox"
							value="may-day"
							:disabled="readonly"
						/>
						<label for="may-day" class="pl-3">May Day</label>
					</div>
					<div class="flex items-center">
						<input
							id="august-bank-holiday"
							v-model="timeconditions.exceptions.fixedExceptions"
							type="checkbox"
							value="august-bank-holiday"
							:disabled="readonly"
						/>
						<label for="august-bank-holiday" class="pl-3">August Bank Holiday</label>
					</div>
					<div class="flex items-center">
						<input
							id="christmas"
							v-model="timeconditions.exceptions.fixedExceptions"
							type="checkbox"
							value="christmas"
							:disabled="readonly"
						/>
						<label for="christmas" class="pl-3">Christmas Day</label>
					</div>
					<div class="flex items-center">
						<input
							id="boxing-day"
							v-model="timeconditions.exceptions.fixedExceptions"
							type="checkbox"
							value="boxing-day"
							:disabled="readonly"
						/>
						<label for="boxing-day" class="pl-3">Boxing Day</label>
					</div>
				</div>
			</div>
		</div>

		<div class="flex flex-col gap-4">
			<div class="mb-6 mt-2 w-full border-b border-dark dark:border-light">
				<h2 class="mb-2">Custom Exceptions</h2>
			</div>
			<div class="flex flex-col gap-4">
				<div
					v-for="(group, i) in timeconditions.exceptions.customRules"
					:key="i"
					class="mt-4 flex flex-col border-t pt-3 first:mt-0 first:border-t-0 first:pt-0"
				>
					<div class="flex flex-col gap-2 px-2 pb-4">
						<div
							v-if="group.length > 0"
							class="hidden justify-between gap-4 sm:flex sm:flex-row sm:items-center"
						>
							<label class="flex-1" for="custom-condition-0">Condition:</label>
							<label class="w-40" for="custom-from">From:</label>
							<label class="w-40" for="custom-to">To:</label>
							<label v-if="!readonly" class="w-16"></label>
						</div>
						<div
							v-if="group.length === 0 && !readonly"
							class="flex flex-col items-center justify-center pb-4"
						>
							<p class="mb-2 text-gray-500">No custom exceptions configured.</p>
							<button class="jmiBtn green w-full sm:w-auto" @click="addRuleToCustomExceptionGroup(i)">
								Add Custom Exception
							</button>
						</div>

						<div
							v-for="(rule, j) in group"
							v-else
							:key="j"
							class="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center sm:gap-4"
						>
							<div class="formGroup withIcon w-full sm:w-auto sm:flex-1">
								<label class="mb-1 block sm:hidden" for="custom-condition">Condition:</label>
								<select
									id="custom-condition"
									v-model="rule.condition"
									:disabled="readonly"
									class="w-full"
									@change="setDefaults(rule)"
								>
									<option value="date-range">Date Range</option>
									<option value="time-of-day">Time of Day</option>
									<option value="day-of-week">Day of Week</option>
									<option value="day-of-month">Day of Month</option>
									<option value="week-of-month">Week of Month</option>
									<option value="week">Week</option>
									<option value="month">Month</option>
									<option value="year">Year</option>
								</select>
								<span class="fa-light fa-chevron-down"></span>
							</div>
							<div
								class="formGroup w-full sm:w-40"
								:class="{
									withIcon: shouldShowIconLow(rule.condition)
								}"
							>
								<label class="mb-1 block sm:hidden" for="custom-from">From:</label>
								<input
									v-if="rule.condition === 'date-range'"
									v-model="rule.from"
									type="date"
									:disabled="readonly"
								/>
								<input
									v-if="rule.condition === 'time-of-day'"
									v-model="rule.from"
									type="time"
									:disabled="readonly"
								/>
								<select
									v-if="rule.condition === 'day-of-week'"
									v-model="rule.from"
									:disabled="readonly"
								>
									<option :value="1">Monday</option>
									<option :value="2">Tuesday</option>
									<option :value="3">Wednesday</option>
									<option :value="4">Thursday</option>
									<option :value="5">Friday</option>
									<option :value="6">Saturday</option>
									<option :value="7">Sunday</option>
								</select>
								<select
									v-if="rule.condition === 'day-of-month'"
									v-model="rule.from"
									:disabled="readonly"
								>
									<option v-for="i in 31" :key="i" :value="i">{{ i }}</option>
								</select>
								<select
									v-if="rule.condition === 'week-of-month'"
									v-model="rule.from"
									:disabled="readonly"
								>
									<option :value="1">1</option>
									<option :value="2">2</option>
									<option :value="3">3</option>
									<option :value="4">4</option>
									<option :value="5">5</option>
								</select>
								<select v-if="rule.condition === 'week'" v-model="rule.from" :disabled="readonly">
									<option v-for="i in 52" :key="i" :value="i">{{ i }}</option>
								</select>
								<select v-if="rule.condition === 'month'" v-model="rule.from" :disabled="readonly">
									<option :value="1">January</option>
									<option :value="2">February</option>
									<option :value="3">March</option>
									<option :value="4">April</option>
									<option :value="5">May</option>
									<option :value="6">June</option>
									<option :value="7">July</option>
									<option :value="8">August</option>
									<option :value="9">September</option>
									<option :value="10">October</option>
									<option :value="11">November</option>
									<option :value="12">December</option>
								</select>
								<span v-if="shouldShowIconLow(rule.condition)" class="fa-light fa-chevron-down"></span>
								<input
									v-if="rule.condition === 'year'"
									v-model="rule.from"
									type="number"
									value="2024"
									:disabled="readonly"
								/>
							</div>
							<div
								class="formGroup w-full sm:w-40"
								:class="{
									withIcon: shouldShowIconLow(rule.condition)
								}"
							>
								<label class="mb-1 block sm:hidden" for="custom-to">To:</label>
								<input
									v-if="rule.condition === 'date-range'"
									v-model="rule.to"
									type="date"
									:disabled="readonly"
								/>
								<input
									v-if="rule.condition === 'time-of-day'"
									v-model="rule.to"
									type="time"
									:disabled="readonly"
								/>
								<select v-if="rule.condition === 'day-of-week'" v-model="rule.to" :disabled="readonly">
									<option :value="1">Monday</option>
									<option :value="2">Tuesday</option>
									<option :value="3">Wednesday</option>
									<option :value="4">Thursday</option>
									<option :value="5">Friday</option>
									<option :value="6">Saturday</option>
									<option :value="7">Sunday</option>
								</select>
								<select v-if="rule.condition === 'day-of-month'" v-model="rule.to" :disabled="readonly">
									<option v-for="i in 31" :key="i" :value="i">{{ i }}</option>
								</select>
								<select
									v-if="rule.condition === 'week-of-month'"
									v-model="rule.to"
									:disabled="readonly"
								>
									<option :value="1">1</option>
									<option :value="2">2</option>
									<option :value="3">3</option>
									<option :value="4">4</option>
									<option :value="5">5</option>
								</select>
								<select v-if="rule.condition === 'week'" v-model="rule.to" :disabled="readonly">
									<option v-for="i in 52" :key="i" :value="i">{{ i }}</option>
								</select>
								<select v-if="rule.condition === 'month'" v-model="rule.to" :disabled="readonly">
									<option :value="1">January</option>
									<option :value="2">February</option>
									<option :value="3">March</option>
									<option :value="4">April</option>
									<option :value="5">May</option>
									<option :value="6">June</option>
									<option :value="7">July</option>
									<option :value="8">August</option>
									<option :value="9">September</option>
									<option :value="10">October</option>
									<option :value="11">November</option>
									<option :value="12">December</option>
								</select>
								<span v-if="shouldShowIconLow(rule.condition)" class="fa-light fa-chevron-down"></span>
								<input
									v-if="rule.condition === 'year'"
									v-model="rule.to"
									type="number"
									value="2024"
									:disabled="readonly"
								/>
							</div>
							<div v-if="!readonly && j === group.length - 1" class="flex w-16 items-center">
								<button
									class="fa-light fa-remove"
									@click="removeRuleFromCustomExceptionGroup(i, j)"
								></button>
								<button class="fa-light fa-add ml-2" @click="addRuleToCustomExceptionGroup(i)"></button>
							</div>
							<div v-if="!readonly && j !== group.length - 1" class="w-16">
								<button
									class="fa-light fa-remove"
									@click="removeRuleFromCustomExceptionGroup(i, j)"
								></button>
							</div>
						</div>
					</div>
					<div
						v-if="!readonly && group.length > 0"
						class="row ml-auto w-full items-center justify-end gap-2 px-2 pt-4"
					>
						<button
							v-if="timeconditions.exceptions.customRules.length > 1"
							class="jmiBtn red w-40"
							@click="removeCustomExceptionGroup(i)"
						>
							Remove Group
						</button>
						<button
							v-if="i === timeconditions.exceptions.customRules.length - 1"
							class="jmiBtn green w-32"
							@click="addCustomExceptionGroup()"
						>
							Add Group
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		savedData: {},
		readonly: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			timeconditions: {
				rules: [
					[
						{
							condition: 'day-of-week',
							from: 1,
							to: 5
						}
					]
				],
				exceptions: {
					fixedExceptions: [],
					customRules: [[]]
				}
			}
		}
	},
	watch: {
		timeconditions: {
			deep: true,
			handler() {
				this.$emit('update', this.timeconditions)
			}
		}
	},
	mounted() {
		if (this.savedData) {
			this.timeconditions = this.savedData
		}
	},
	methods: {
		addGroup() {
			if (!this.readonly) {
				this.timeconditions.rules.push([
					{
						condition: 'day-of-week',
						from: 1,
						to: 5
					}
				])
			}
		},
		shouldShowIconLow(condition) {
			return ['day-of-week', 'day-of-month', 'week-of-month', 'week', 'month'].includes(condition)
		},
		removeRuleGroup(index) {
			if (!this.readonly) {
				this.timeconditions.rules.splice(index, 1)
			}
		},
		addCustomExceptionGroup() {
			if (!this.readonly) {
				this.timeconditions.exceptions.customRules.push([
					{
						condition: 'day-of-week',
						from: 1,
						to: 5
					}
				])
			}
		},
		removeCustomExceptionGroup(index) {
			if (!this.readonly) {
				this.timeconditions.exceptions.customRules.splice(index, 1)
			}
		},
		addRuleToGroup(i) {
			if (!this.readonly) {
				this.timeconditions.rules[i].push({
					condition: 'day-of-week',
					from: 1,
					to: 5
				})
			}
		},
		removeRuleFromGroup(i, j) {
			if (!this.readonly) {
				this.timeconditions.rules[i].splice(j, 1)
			}
		},
		addRuleToCustomExceptionGroup(i) {
			this.timeconditions.exceptions.customRules[i].push({
				condition: 'day-of-week',
				from: 1,
				to: 5
			})
		},
		removeRuleFromCustomExceptionGroup(i, j) {
			if (!this.readonly) {
				this.timeconditions.exceptions.customRules[i].splice(j, 1)
				if (
					this.timeconditions.exceptions.customRules[i].length === 0 &&
					this.timeconditions.exceptions.customRules.length > 1
				) {
					this.timeconditions.exceptions.customRules.splice(i, 1)
				}
			}
		},
		setDefaults(rule) {
			switch (rule.condition) {
				case 'date-range':
					rule.from = new Date().toISOString().split('T')[0]
					rule.to = new Date().toISOString().split('T')[0]
					break
				case 'time-of-day':
					rule.from = '00:00'
					rule.to = '23:59'
					break
				case 'day-of-week':
					rule.from = 1
					rule.to = 5
					break
				case 'day-of-month':
					rule.from = 1
					rule.to = 31
					break
				case 'week-of-month':
					rule.from = 1
					rule.to = 5
					break
				case 'week':
					rule.from = 1
					rule.to = 52
					break
				case 'month':
					rule.from = 1
					rule.to = 12
					break
				case 'year':
					rule.from = new Date().getFullYear()
					rule.to = new Date().getFullYear()
					break
			}
		}
	}
}
</script>

<style scoped>
input[type='checkbox'] {
	margin: 0;
}
label {
	padding: 0 0 2px 0;
}
</style>
